export default __webpack_public_path__ + "static/media/minicard6.9aa04412.jpg";